module.exports = __webpack_public_path__ + "static/media/sri-lanka.1937c329.png";